namespace Matrix.Rebalancer {
    export interface SummaryViewColumnForm {
        ViewCode: Serenity.StringEditor;
        FieldName: Serenity.StringEditor;
        Area: Serenity.LookupEditor;
        AreaIndex: Serenity.IntegerEditor;
        Header: Serenity.StringEditor;
        DataFieldName: Serenity.StringEditor;
        Expression: Serenity.StringEditor;
        DataType: Serenity.LookupEditor;
        SummaryType: Serenity.LookupEditor;
        SummaryDisplayType: Serenity.LookupEditor;
        FormatString: Serenity.LookupEditor;
        SortFieldName: Serenity.StringEditor;
        SortSummaryType: Serenity.LookupEditor;
        ShowTotals: Serenity.BooleanEditor;
        ShowGrandTotal: Serenity.BooleanEditor;
        Visible: Serenity.BooleanEditor;
        ActionTemplate: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SummaryViewColumnForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.SummaryViewColumn';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SummaryViewColumnForm.init)  {
                SummaryViewColumnForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.BooleanEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(SummaryViewColumnForm, [
                    'ViewCode', w0,
                    'FieldName', w0,
                    'Area', w1,
                    'AreaIndex', w2,
                    'Header', w0,
                    'DataFieldName', w0,
                    'Expression', w0,
                    'DataType', w1,
                    'SummaryType', w1,
                    'SummaryDisplayType', w1,
                    'FormatString', w1,
                    'SortFieldName', w0,
                    'SortSummaryType', w1,
                    'ShowTotals', w3,
                    'ShowGrandTotal', w3,
                    'Visible', w3,
                    'ActionTemplate', w0,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
